import { cn as N } from "../../../lib/shadcn/utils/utils.js";
import { Button as $ } from "../../../lib/shadcn/ui/components/button.js";
import h from "../../../assets/svg/Spinner/Spinner.js";
import { getIconByName as l } from "../../../helpers/icon.helper.js";
import { useMemo as u } from "react";
import { jsx as b } from "react/jsx-runtime";
import { useFormStatus as j } from "react-dom";
var w = ({ title: t, dataTestid: f, className: p, type: r = "button", variant: B = "default", startIcon: a, endIcon: n, children: g, loading: m, size: S = !t && a ? "icon" : "default", disabled: s, onClick: x, ...o }) => {
  const { pending: c } = j(), i = u(() => !!(m || c && r === "submit"), [m, c]), d = u(() => !!(s || i), [s, i]), y = typeof a == "string" ? l(a) : a, L = typeof n == "string" ? l(n) : n, v = o["aria-label"], e = t ?? v, A = e ? {
    "aria-label": e,
    title: t
  } : {};
  return /* @__PURE__ */ b($, {
    ...o,
    "data-qa-ta": `button-${o.name ?? t ?? e ?? ""}`,
    "data-dd-action-name": o.name,
    role: "button",
    "aria-disabled": d,
    "data-testid": f,
    className: p,
    type: r,
    variant: B,
    size: S,
    startIcon: y,
    endIcon: L,
    disabled: d,
    onClick: x,
    ...A,
    children: i ? /* @__PURE__ */ b(h, { className: N("size-6") }) : g
  });
};
export {
  w as Button
};

//# sourceMappingURL=Button.js.map